import { isNil, replace, toLower } from 'lodash';

export const removeVietnameseAccents = (text: string | null | undefined) =>
  isNil(text)
    ? ''
    : replace(replace(toLower(text.normalize('NFD')), /đ/g, 'd'), /[\u0300-\u036f]/g, '');
